
<div class="col" *appUserRoleUp="[Role.Admin]">
  <span class="input-group-name">Upload drawing directly to this equipment</span>
  <app-drag-drop [format]="'.pdf,.xlsx,.xls,.msg'"
                 (fileListChanged)="onFileDropped($event)">
    <app-empty-list-holder [description]="'Select a PDF, Excel or .msg file'"
                           [icon]="'cloud_upload'"
                           class="col drag-drop-container">
      <p>or drag &amp; drop it here</p>
    </app-empty-list-holder>
  </app-drag-drop>

  <div class="col" *ngIf="pendingFiles.length > 0">
    <span class="input-group-name">Files to upload when this equipment is saved</span>
    <div class="row pending-file"
         *ngFor="let file of pendingFiles"
         style="display: flex; align-items: center;">
      <mat-icon>insert_drive_file</mat-icon>
      <span style="margin-left: 8px;">{{ file.name }}</span>
      <button mat-icon-button
              matTooltip="Remove file"
              aria-label="Remove file"
              (click)="removePendingFile(file)">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>
</div>

<mat-divider></mat-divider>

  <div class="col" *ngIf="canShowDrawings; else noDrawingTemplate">
    <mat-toolbar class="page-toolbar add-space" *ngIf="canShowDrawings">
      <button *appUserRoleUp="[Role.Admin]"
              class="btn btn-primary margin-left-md"
              (click)="onAddDrawing();">
        Assign Drawing
      </button>
      <mat-form-field class="fx-33 filter-panel" style="display: block !important;">
        <input matInput
               placeholder="Search"
               (keyup)="onKey($event)">
      </mat-form-field>
    </mat-toolbar>


    <app-drawing-table [data]="visibleDrawings"
                       [columnsToDisplay]="drawingColumnsToDisplay"
                       [filter]="filter"
                       [showStandaloneTag]="true"
                       (removeFromCollection)="onRemoveDrawing($event)"
                       (collectionChanged)="onDrawingCollectionChanged($event)">
    </app-drawing-table>
  </div>


<ng-template #noDrawingTemplate>
  <app-empty-list-holder [description]="'No Drawing assigned yet.'">
    <button *appUserRoleUp="[ Role.Admin ]"
            class="btn btn-primary"
            (click)="onAddDrawing();">
      Assign Drawing
    </button>
  </app-empty-list-holder>
</ng-template>

